import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

// REDUX
import {
  fetchShippingRoutes,
  setShowOrdersListModal,
  setShowShippingRouteModal,
  setShowShippingRouteShowModal,
} from "../../store/actions/shippingRoutesSlice";
//APP COMPONENTS
import ShippingRouteModal from "../shipping/ShippingRouteModal";
import AvailableOrdersList from "../shipping/routes/AvailableOrdersList";
import ShippingRouteShowModal from "../shipping/ShippingRouteShowModal";

export default function ShippingRouteManager() {
  const dispatch = useDispatch();

  const showShippingRouteModal = useSelector(
    (state) => state.shippingRoutes.showShippingRouteModal
  );

  const shippingRouteShowId = useSelector(
    (state) => state.shippingRoutes.shippingRouteShowId
  );

  const showShippingRouteShowModal = useSelector(
    (state) => state.shippingRoutes.showShippingRouteShowModal
  );

  const showOrdersListModal = useSelector(
    (state) => state.shippingRoutes.showOrdersListModal
  );

  const handleCloseShippingRouteModal = useCallback(() => {
    dispatch(setShowShippingRouteModal({ show: false, shippingRoute: null }));
  }, []);

  const handleShowShippingRouteShowModal = useCallback(() => {
    dispatch(setShowShippingRouteShowModal({ show: false, id: null }));
  }, []);

  const handleOrdersListOnClose = () => {
    dispatch(setShowOrdersListModal(!showOrdersListModal));
  };

  const loadShippingRoutes = async () => {
    try {
      dispatch(fetchShippingRoutes({}));
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      {showShippingRouteModal && (
        <ShippingRouteModal
          show={showShippingRouteModal}
          closeModal={handleCloseShippingRouteModal}
        />
      )}

      {showShippingRouteShowModal && (
        <ShippingRouteShowModal
          show={showShippingRouteShowModal}
          closeModal={handleShowShippingRouteShowModal}
          shippingRouteId={shippingRouteShowId}
        />
      )}

      <AvailableOrdersList
        show={showOrdersListModal}
        onClose={handleOrdersListOnClose}
        loadRoutesData={loadShippingRoutes}
      />
    </>
  );
}
